export default __webpack_public_path__ + "static/akademia-bg-53386ab8e680168be58037cf4c2877d7.jpg";